<template>
  <b-container fluid>
    <b-container>
      <b-row class="d-flex justify-content-end mb-3">
        <router-link :to="{name:'Login',query:{redirect:'UserUnpaidOrder'}}">
          <b-button variant="primary" pill>{{ continueProcessText }}</b-button>
        </router-link>
      </b-row>
    </b-container>

    <b-container>
      <div class="page-title">
        <h4 class="text-primary">سبد خرید</h4>
      </div>
    </b-container>

    <b-container v-if="IsEmpty" class="main-row">
      <b-row>
        <b-col class="d-flex flex-column justify-content-center align-items-center">
          <img alt="shopping cart" id="empty-basket-img" :src="EmptyCartImage"/>
          <h4 class="text-dark">سبد خرید شما خالی است!</h4>
        </b-col>
      </b-row>
    </b-container>

    <b-container v-else class="main-row">

      <div class="my-3 row text-center">
        <div class="col-lg-6" v-for="(product,index) in getProductList" :key="index">
          <m-c304 v-for="(sub_product,index) in subProducts(product)" :key="index" class="col-lg-12  border border-1 my-1"
                  v-if="findHashProductOnLocalStorage(sub_product) != undefined"
                  :image="sub_product.thumbnail" :alt="sub_product.name">
            <template #p-1>

              <h5>{{ sub_product.name }}</h5>
              <del v-if="productPriceOnUnAuthShoppingCard(sub_product)['offer'] > 0">{{  formatNumber(productPriceOnUnAuthShoppingCard(sub_product)['price'])  }}</del>
              <p>{{ formatNumber(productPriceOnUnAuthShoppingCard(sub_product)['price'] - productPriceOnUnAuthShoppingCard(sub_product)['offer']) }}</p>

            </template>
            <template #p-2>
              <m-shopping-cart-controller-1 :product="product"/>
            </template>
          </m-c304>

        </div>
      </div>

      <m-un-auth-summary-1 :products="getProductList"/>


    </b-container>

  </b-container>
</template>

<script>

/*
* اگر میخوای به محصول متغیر در حالت un auth قابلیت counter مربوط به quantity رو اضافه کنی از کد های داخل unAuthCard_old استفاده کن.
*
*
*
*
* */


import {mapGetters} from "vuex";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {
  subProducts,
  productPriceOnUnAuthShoppingCard
} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import {findHashProductOnLocalStorage} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart';

export default {
  name: "UnAuthenticatedShoppingCart1",
  props: {
    EmptyCartImage: {
      default: 'https://picsum.photos/500/500'
    },
    continueProcessText: {
      default: 'ورود به حساب کاربری و ادامه فرایند خرید'
    }
  },
  data() {
    return {};
  },
  methods: {
    formatNumber,
    findHashProductOnLocalStorage,
    productPriceOnUnAuthShoppingCard,
    subProducts,
  },
  computed: {
    IsEmpty() {
      return localStorage.getItem('products') === null || Object.keys(JSON.parse(localStorage.products)).length === 0;
    },
    getItems() {
      let productsLink = [];
      let productsJson = JSON.parse(localStorage.getItem('products'))

      if (productsJson !== null) {
        Object.keys(productsJson).forEach(function (key) {
          productsLink.push(productsJson[key]['product'])
        })
      }

      // unique productsLink
      let uniqueProductsLink = productsLink.filter(function (item, i, ar) {
        return ar.indexOf(item) === i;
      })

      return uniqueProductsLink
    },
    ...mapGetters({
      getProductList: "ShoppingCart/getProductList"
    }),
  },
  mounted() {
    this.$store.dispatch("ShoppingCart/getProductList", this.getItems)
  },
};
</script>

<style scoped>
.page-title {
  border-bottom: 1px solid var(--light-white) !important;
}

.page-title h4 {
  height: 100%;
  width: 120px;
  text-align: center;
  font-size: 18px;
  line-height: 1;
  padding-bottom: 5px;
  margin-bottom: 0;
  border-bottom: 3px solid var(--secondary) !important;
}

.main-row {
  padding-top: 30px;
}

#empty-basket-img {
  max-width: 250px;
  max-height: 250px;
}
</style>